import {
  apiClient,
} from "./apiClient";

import type {
  CreateWarehouseInput,
  DeleteWarehouseData,
  UpdateWarehouseInput,
  WarehouseItemData,
  WarehousesPageData,
  WarehousesQuery,
} from "../types/warehouses.types";


function buildWarehousesQuery(
  query:
    WarehousesQuery = {},
): string {
  const params =
    new URLSearchParams();


  if (
    query.search?.trim()
  ) {
    params.set(
      "search",
      query.search.trim(),
    );
  }


  if (
    query.province?.trim()
  ) {
    params.set(
      "province",
      query.province.trim(),
    );
  }


  if (
    query.isActive !==
    undefined
  ) {
    params.set(
      "isActive",
      String(
        query.isActive,
      ),
    );
  }


  if (
    query.isDefault !==
    undefined
  ) {
    params.set(
      "isDefault",
      String(
        query.isDefault,
      ),
    );
  }


  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }


  if (
    query.cursor?.trim()
  ) {
    params.set(
      "cursor",
      query.cursor.trim(),
    );
  }


  if (
    query.limit !==
    undefined
  ) {
    params.set(
      "limit",
      String(
        query.limit,
      ),
    );
  }


  const queryString =
    params.toString();


  return queryString
    ? `?${queryString}`
    : "";
}


export const warehousesApi = {

  list(
    query:
      WarehousesQuery = {},
  ) {
    return apiClient.get<
      WarehousesPageData
    >(
      `/warehouses${buildWarehousesQuery(
        query,
      )}`,
    );
  },


  getById(
    warehouseId: string,
  ) {
    return apiClient.get<
      WarehouseItemData
    >(
      `/warehouses/${encodeURIComponent(
        warehouseId,
      )}`,
    );
  },


  create(
    input:
      CreateWarehouseInput,
  ) {
    return apiClient.post<
      WarehouseItemData
    >(
      "/warehouses",
      input,
    );
  },


  update(
    warehouseId: string,

    input:
      UpdateWarehouseInput,
  ) {
    return apiClient.patch<
      WarehouseItemData
    >(
      `/warehouses/${encodeURIComponent(
        warehouseId,
      )}`,
      input,
    );
  },


  delete(
    warehouseId: string,
  ) {
    return apiClient.delete<
      DeleteWarehouseData
    >(
      `/warehouses/${encodeURIComponent(
        warehouseId,
      )}`,
    );
  },
};